<template>
  <card-component  class="has-table has-mobile-sort-spaced" style="min-height: 400px">
    <section slot="content">
      <b-tabs
        class="dark-tabs"
        type="is-boxed"
        v-model="activeGroupTab"
        @input="tabClicked"
        :animated="false">
        <b-tab-item v-for="(group, index) in groups" :label="group.title" :key="`tab-${index}`">
            <b-tabs
              :class="['dark-tabs', {'hidde-scroll-tabs': hiddenScroll} ]"
              type="is-boxed"
              v-model="activeDayTab"
              :animated="false"
              @input="tabDayClicked($event, group)"
              >
                <b-tab-item v-for="(day, indexDay) in group.days" :key="`tab-day-${indexDay}`">
                  <template slot="header">
                    <p>{{ day.title }}</p>
                    <b-dropdown aria-role="list" @active-change="toggleScroll">
                      <b-icon :icon="'dots-vertical'" slot="trigger" style="margin-right: 0px;"></b-icon>
                      <b-dropdown-item aria-role="listitem" @click="editDay(day)">Editar</b-dropdown-item>
                      <!-- <b-dropdown-item aria-role="listitem" @click="deleteDay(group, index, day, indexDay)">Eliminar</b-dropdown-item> -->
                    </b-dropdown>
                  </template>
                  <iron-work-table :tasks="day.data" :date="day.date" :group-id="group.id" :service-id="serviceId" @reload="mapGroups"/>
                </b-tab-item>
                <b-tab-item>
                  <template slot="header">
                    <b-icon
                      icon="plus-circle">
                    </b-icon>
                  </template>
                </b-tab-item>
            </b-tabs>
        </b-tab-item>
        <b-tab-item label="Grupos de Herraje" v-if="groups.length === 0 && !isLoading">
          <div class="no-ironworks-container has-text-grey has-text-centered">
              <p>
                <b-icon icon="horseshoe" size="is-large" />
              </p>
              <p>No hay herrajes registrados&hellip;</p>
              <br>
              <p><b>Comience agregando un nuevo grupo de Herraje <br> haciendo click en el botón</b></p>
              <br>
              <b-icon icon="plus-circle" size="is-large"> </b-icon>
          </div>
        </b-tab-item>
        <b-tab-item>
          <template slot="header">
            <b-icon
              icon="plus-circle">
            </b-icon>
          </template>
        </b-tab-item>
      </b-tabs>
      <group-modal :active.sync="isGroupModalActive" @confirm="createGroupWithDay" :selected-days="selectedDays" :selected-groups="selectedGroups" :start-day="firstDate" :start-date="startDate" :end-date="endDate"/>
      <day-name-modal :active.sync="isDayModalActive" @confirm="createDay" :selected-days="selectedDays" :day-edit="selectedDay" :start-day="firstDate" :start-date="startDate" :end-date="endDate"/>
      <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    </section>
  </card-component>
</template>

<script>
import ServiceService from '@/services/ServiceService'
import TaskUserService from '@/services/TaskUserService'
import CardComponent from '@/components/CardComponent'
import DayNameModal from './DayNameModal'
import GroupModal from './GroupModal'
import IronWorkTable from './IronWorksTable'

export default {
  props: {
    reload: {
      type: Boolean,
      default: false
    },
    serviceId: {
      required: true
    },
    startDate: {
      type: Date,
      default: null
    },
    endDate: {
      type: Date,
      default: null
    }
  },
  components: {
    CardComponent,
    DayNameModal,
    IronWorkTable,
    GroupModal
  },
  created () {
    this.mapGroups()
  },
  data () {
    return {
      groups: [
      ],
      activeGroupTab: 0,
      oldGroupTab: 0,
      activeDayTab: 0,
      oldDayTab: 0,
      isDayModalActive: false,
      isGroupModalActive: false,
      selectedGroup: null,
      selectedDay: null,
      hiddenScroll: false,
      isLoading: false,
      eventsTypes: [
        'is-primary',
        'is-success',
        'is-warning',
        'is-info',
        'is-danger',
        'is-link'
      ]
    }
  },
  methods: {
    editDay (day) {
      this.selectedDay = day
      this.isDayModalActive = true
    },
    deleteDay (group, indexGroup, day, indexDay) {
      this.$buefy.dialog.confirm({
        title: 'Eliminar Día',
        message: '¿Está seguro que desea <b>eliminar</b> el día? <br> Esta acción no se puede revertir.',
        confirmText: 'Eliminar',
        cancelText: 'Cacelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          group.days.splice(indexDay, 1)
          if (group.days.length === 0) {
            this.groups.splice(indexGroup, 1)
          }
          this.$buefy.toast.open('Account deleted!')
        }
      })
    },
    toggleScroll (active) {
      if (active) {
        this.hiddenScroll = true
      } else {
        this.hiddenScroll = false
      }
    },
    async mapGroups () {
      this.isLoading = true
      let arrayGroups = await this.getServiceGroups()
      let groups = []
      for (let index = 0; index < arrayGroups.length; index++) {
        const groupId = arrayGroups[index]
        let taskOfDay = await this.getTaskUser(groupId)
        let mapTask = taskOfDay.map((element, index) => {
          return {
            title: this.$moment(element.date, 'YYYY-MM-DD').format('L'),
            date: this.$moment(element.date, 'YYYY-MM-DD').toDate(),
            data: element.data
          }
        })
        let group = {
          id: groupId,
          title: `Grupo ${groupId}`,
          days: mapTask
        }
        groups.push(group)
      }
      this.groups = groups
      this.isLoading = false
    },
    async getServiceGroups () {
      let response = await ServiceService.getServiceGroups(this.serviceId)
      if (response.status === 200) {
        return response.data
      }
    },
    async getTaskUser (groupId) {
      let params = {
        'type': 'horseshoe',
        'group_id': groupId,
        'service_id': this.serviceId,
        'by_day_array': true,
        'include[0]': 'horse.type.category',
        'include[1]': 'taskable'
      }
      let response = await TaskUserService.getTaskUsers(params)
      if (response.status === 200) {
        return response.data
      } else {
        return []
      }
    },
    tabClicked (index) {
      this.activeGroupTab = index
      this.$nextTick(() => {
        if (this.eventsTypes.length > this.groupCount || index < this.groupCount) {
          if ((index === this.groupCount && this.groupCount !== 0) || (index === 1 && this.groupCount === 0)) {
            this.activeGroupTab = this.oldGroupTab
            this.$nextTick(() => {
              this.activeDayTab = this.oldDayTab
            })
            this.isGroupModalActive = true
          }
        } else {
          this.activeGroupTab = this.oldGroupTab
          this.$buefy.dialog.alert('El máximo de grupos creados es de 6.')
        }
      })
    },
    tabDayClicked (index, group) {
      this.activeDayTab = index
      this.$nextTick(() => {
        let daysCount = group.days.length
        if (index === daysCount) {
          this.activeDayTab = this.oldDayTab
          this.isDayModalActive = true
          this.selectedGroup = group
        }
      })
    },
    createGroupWithDay (data) {
      let formatDate = this.$moment(data.date).format('DD/MM/YYYY')
      let tab = { title: formatDate, date: data.date }
      let group = { id: data.group, title: `Grupo ${data.group}`, days: [] }
      group.days.push(tab)
      this.groups.push(group)
      this.activeDayTab = group.days.length - 1
      this.sortGroups()
      let newIndex = this.groups.findIndex((x) => x.id === group.id)
      this.activeGroupTab = newIndex
    },
    createDay (date) {
      if (date && this.selectedDay) {
        let formatDate = this.$moment(date).format('DD/MM/YYYY')
        this.selectedDay.title = formatDate
        this.selectedDay.date = date
        this.selectedDay = null
      } else {
        let formatDate = this.$moment(date).format('DD/MM/YYYY')
        let tab = { title: formatDate, date: date }
        this.selectedGroup.days.push(tab)
        this.activeDayTab = this.selectedGroup.days.length - 1
        this.selectedGroup = null
      }
    },
    sortGroups () {
      this.groups.sort((a, b) => a.id - b.id)
    }
  },
  computed: {
    selectedGroups () {
      return this.groups.map((x) => x.id)
    },
    groupCount () {
      return this.groups.length
    },
    selectedDays () {
      let daysGroup = []
      for (let index = 0; index < this.groups.length; index++) {
        const group = this.groups[index]
        const type = this.eventsTypes[index]
        if (group.days) {
          let days = group.days
          for (let index = 0; index < days.length; index++) {
            const day = days[index]
            let dayMap = {
              date: day.date,
              type: type
            }
            daysGroup.push(dayMap)
          }
        }
      }
      return daysGroup
    },
    firstDate () {
      if (this.selectedGroup && this.selectedGroup.days) {
        let lastDay = this.selectedGroup.days.slice(-1)[0]
        return lastDay ? lastDay.date : new Date()
      } else {
        return this.startDate
      }
    }
  },
  watch: {
    activeGroupTab (newValue, oldValue) {
      this.oldGroupTab = oldValue
      this.activeDayTab = 0
    },
    activeDayTab (newValue, oldValue) {
      this.oldDayTab = oldValue
    }
  }
}
</script>
<style>
  .no-ironworks-container{
    padding: 8rem 0rem;
  }
  .hidde-scroll-tabs .tabs{
    overflow: visible !important;
  }
</style>
